const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const Dropdown = require("./SchoolDropdown");
const URLMake = require("../../shared/URLMake");
const Link = require("../core/view/Link");
const withSetURL = require("../core/hoc/withSetURL");
const OpsSchool = require("./vault/OpsSchool");
const ClassesUtil = require("./util/ClassesUtil");
const HoverText = require("../core/view/HoverText");

const styles = require("./styles/Breadcrumbs.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withSetURL(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "Breadcrumbs",

		propTypes: {
			user: PT.object.isRequired,
			pageData: PT.object.isRequired,
			schoolState: PT.object.isRequired,
			tab: PT.string,
			forReport: PT.bool,

			// Injected by HOCs
			setURL: PT.func.isRequired,
		},

		hoverCrumb: function(text, content) {
			return (
				<HoverText
					text={text}
					key={"hoverCrumb" + text.replace(/\s/g, "")}
					size="large"
					direction="b"
					canWrap={true}
				>
					{content}
				</HoverText>
			);
		},

		makeCrumbLink: function(to, text) {
			return (
				<Link to={to} className={styles.crumbLink}>
					{text}
				</Link>
			);
		},

		makeDropdown: function(scope, options, initialValue) {
			return (
				<Dropdown
					className={styles.crumbDropdown}
					options={options}
					initialValue={initialValue.toString()}
					updateSelection={val => this.updateCrumbSelection(scope, val)}
					style="crumb"
					optionHeight={34}
					orderOptions="asc"
				/>
			);
		},

		updateCrumbSelection: function(scope, val) {
			const {pageData, tab} = this.props;
			const newID = parseInt(val);
			if (scope === "school" && newID !== pageData.schoolID) {
				const pd = _.extend({}, pageData, {schoolID: newID});
				this.props.setURL(URLMake.forSchool("reports", tab, pd));
			} else if (scope === "class" && newID !== pageData.classID) {
				this.props.setURL(URLMake.forClassReport(newID, pageData));
			} else if (scope === "student" && newID !== pageData.studentID) {
				this.props.setURL(URLMake.forStudentReport(newID, pageData));
			}
		},

		render: function() {
			const {pageData, schoolState, user, forReport} = this.props;
			const {schoolID, classID, userID, studentID} = pageData;
			const {accounts} = schoolState;
			const space = forReport ? "reports" : "accounts";
			const viewableSchools = forReport
				? OpsSchool.getEditableSchools(schoolState, user.userID)
				: OpsSchool.getViewableSchools(schoolState, user.userID);
			let viewableClasses = forReport
				? OpsSchool.getEditableClasses(schoolState, user.userID)
				: OpsSchool.getViewableClasses(schoolState, user.userID);
			const viewableClassIDs = viewableClasses.map(vc => vc.id);

			let tab;
			if (schoolID) tab = "schools";
			else if (classID) tab = "classes";
			else if (userID) {
				if (OpsSchool.isStaff(schoolState, userID)) tab = "staff";
				else tab = "students";
			}
			const path = [];
			const purchaseName = _.get(accounts, "purchase.displayName");
			const isSingleSchool = _.get(accounts, "purchase.isSingleSchool");
			const isPurchaseAdmin = OpsSchool.isPurchaseAdmin(
				schoolState,
				user.userID
			);

			// Purchase path
			if (!(schoolID || classID || userID || studentID)) {
				path.push(
					this.hoverCrumb(
						purchaseName,
						<span className={styles.crumbItem}>{purchaseName}</span>
					)
				);
			} else if (viewableSchools.length || isPurchaseAdmin) {
				path.push(
					this.hoverCrumb(
						purchaseName,
						this.makeCrumbLink(URLMake.forSchool(space, tab), purchaseName)
					)
				);
			}
			// School -> Class -> Student
			let schoolName, className;
			if (schoolID && !isSingleSchool) {
				// School name
				schoolName = _.get(accounts, ["schools", schoolID, "displayName"]);
				if (viewableSchools.length > 1 && forReport) {
					const schoolOptions = _.zipObject(
						viewableSchools.map(s => s.id),
						viewableSchools.map(s => s.displayName)
					);
					path.push(
						this.makeDropdown("school", schoolOptions, pageData.schoolID)
					);
				} else {
					path.push(
						this.hoverCrumb(
							schoolName,
							<span className={styles.crumbItem}>{schoolName}</span>
						)
					);
				}
			} else if (classID) {
				// School name
				const classSchool = OpsSchool.getSchoolForClass(schoolState, classID);
				schoolName = classSchool.displayName;
				const classes = OpsSchool.getClassesForSchool(
					schoolState,
					classSchool.id
				);
				viewableClasses = _.filter(viewableClasses, vc =>
					_.includes(
						classes.map(c => c.id),
						vc.id
					)
				);
				if (!isSingleSchool) {
					if (!forReport || viewableClasses.length > 1 || isPurchaseAdmin) {
						path.push(
							this.hoverCrumb(
								schoolName,
								this.makeCrumbLink(
									URLMake.forSchool(space, tab, {
										schoolID: classSchool.id,
									}),
									schoolName
								)
							)
						);
					} else {
						path.push(
							this.hoverCrumb(
								schoolName,
								<span className={styles.crumbItem}>{schoolName}</span>
							)
						);
					}
				}
				// class name
				className = _.get(accounts, ["classes", classID, "displayName"]);
				if (
					viewableClasses.length > 1 &&
					OpsSchool.isClassActive(schoolState, classID) &&
					forReport
				) {
					const filteredClasses = _.filter(viewableClasses, c => c.active);
					const classOptions = _.zipObject(
						filteredClasses.map(s => s.id),
						filteredClasses.map(s => s.displayName)
					);
					path.push(this.makeDropdown("class", classOptions, pageData.classID));
				} else {
					path.push(
						this.hoverCrumb(
							className,
							<span className={styles.crumbItem}>{className}</span>
						)
					);
				}
			} else if (userID || studentID) {
				const idToUse = userID || studentID;
				const isStaff = !studentID && OpsSchool.isStaff(schoolState, idToUse);
				const targetUser = OpsSchool.getUser(schoolState, idToUse);
				if (isStaff) {
					const userName = ClassesUtil.getUserName(targetUser);
					path.push(
						this.hoverCrumb(
							userName,
							<span className={styles.crumbItem}>{userName}</span>
						)
					);
				} else {
					const studentSchool = OpsSchool.getSchoolForStudent(
						schoolState,
						idToUse
					);
					const studentClass = OpsSchool.getClassForStudent(
						schoolState,
						idToUse
					);
					schoolName = studentSchool.displayName;
					className = studentClass.displayName;
					// school name
					if (!isSingleSchool) {
						path.push(
							this.hoverCrumb(
								schoolName,
								this.makeCrumbLink(
									URLMake.forSchool(space, tab, {
										schoolID: studentSchool.id,
									}),
									schoolName
								)
							)
						);
					}

					// Class name
					if (
						_.includes(viewableClassIDs, studentClass.id) ||
						isPurchaseAdmin
					) {
						path.push(
							this.hoverCrumb(
								className,
								this.makeCrumbLink(
									URLMake.forSchool(space, tab, {
										classID: studentClass.id,
										..._.pick(pageData, [
											"grade",
											"chapter",
											"block",
											"typeID",
										]),
									}),
									className
								)
							)
						);
					} else {
						path.push(
							this.hoverCrumb(
								className,
								<span className={styles.crumbItem}>{className}</span>
							)
						);
					}
					const studentName = ClassesUtil.getStudentName(targetUser);
					if (forReport) {
						const studentsInClass = OpsSchool.getStudentsForClass(
							schoolState,
							studentClass.id
						);
						const filteredStudents = _.filter(
							studentsInClass,
							sic => sic.active
						);
						const studentOptions = _.zipObject(
							filteredStudents.map(s => s.id),
							filteredStudents.map(s => ClassesUtil.getStudentName(s))
						);
						path.push(
							this.makeDropdown("student", studentOptions, pageData.studentID)
						);
					} else {
						path.push(
							this.hoverCrumb(
								studentName,
								<span className={styles.crumbItem}>{studentName}</span>
							)
						);
					}
				}
			}
			const crumbsEl = [];
			const crumbClass = forReport ? styles.reportCrumbs : styles.accountCrumbs;
			_.each(path, (crumb, i) => {
				if (i !== 0) {
					crumbsEl.push(
						<span key={"divider" + i} className={styles.crumbDivider}>
							U
						</span>
					);
				}
				crumbsEl.push(
					<span key={"crumb" + i} className={styles.crumb}>
						{crumb}
					</span>
				);
			});
			return <div className={crumbClass}>{crumbsEl}</div>;
		},
	})
);
